import { useNavigate, useParams } from "@tanstack/react-router"

import {
  DataTable,
  dataTableFeatures,
  useTable,
  type DataTableInstance,
} from "@atlant/ui"

import { tableSettingsOptions } from "#lib/table-settings.ts"

import { fleetColumns } from "./fleet-columns.tsx"
import { fleetTableDefaults, useFleetTableSettings } from "./fleet-table-store.ts"
import type { FleetRow } from "./fleet-table-types.ts"

export const useFleetTable = (data: FleetRow[]) =>
  useTable({
    features: dataTableFeatures,
    columns: fleetColumns,
    data,
    getRowId: (row) => row.id,
    columnResizeMode: "onChange",
    initialState: fleetTableDefaults,
    ...tableSettingsOptions(useFleetTableSettings()),
  })

export const FleetTable = ({ table }: { table: DataTableInstance<FleetRow> }) => {
  const { slug } = useParams({ from: "/_authenticated/$slug" })
  const navigate = useNavigate()

  return (
    <DataTable
      table={table}
      className="max-h-full"
      empty="No aircraft match your filters"
      onRowClick={(row) =>
        navigate({
          to: "/$slug/fleet/$aircraftId/overview",
          params: { slug, aircraftId: row.original.id },
        })
      }
    />
  )
}
